export default __webpack_public_path__ + "static/media/pattern-circles.f4df3610.svg";